/* app/js/src/components/live-sources/live-sources-container/live-sources-container.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  min-height: 0;
}
.live-sources-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background-color: rgb(235, 240, 244);
}
.live-sources-header {
  flex-shrink: 0;
  padding: 24px 32px 8px;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
  gap: 0;
}
.live-sources-content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.live-sources-header__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}
.live-sources-header__title-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.live-sources-title {
  font-family: "Open Sans", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
}
.live-sources-header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.live-sources-header__btn {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.live-sources-header__btn:focus {
  outline: none;
  box-shadow: none;
}
.live-sources-header__btn--primary {
  background-color: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
}
.live-sources-header__btn--primary:hover:not(:disabled) {
  background-color: rgb(41, 170, 229);
}
.live-sources-loading,
.live-sources-error {
  padding: 24px;
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
}
.live-sources-error button {
  margin-top: 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border: 1px solid rgb(45, 187, 252);
  border-radius: 6px;
  background: transparent;
  color: rgb(45, 187, 252);
  cursor: pointer;
}
.live-sources-error button:hover {
  background: rgba(45, 187, 252, 0.08);
}
/*# sourceMappingURL=live-sources-container.component.css.map */
